import styled, { css } from 'styled-components';
import { StyledSection } from '@components/section/Section.styles';
import { device } from '@styles/tools/breakpoints.styles';

export const ErrorPageSection = styled(StyledSection)`
  padding: ${props => `${props.theme.space[5]}px`};
  max-width: 920px;

  ${device.mobile} {
    padding: ${props => `${props.theme.space[2]}px ${props.theme.space[3]}px`};
    text-align: center;
  }
`;

export const Description404 = styled.div`
  order: 1;

  ${device.mobile} {
    order: 2;
  }
`;
export const H1 = styled.h1`
  font-size: 7.2rem;
  line-height: 1;
  color: ${props => props.theme.colors.purple700};
  margin: 0;

  ${device.mobile} {
    font-size: 5rem;
  }
`;

export const H2 = styled.h2`
  font-size: ${props => props.theme.fontSizes[4]};
  line-height: 32px;
  color: ${props => props.theme.colors.grey700};
  font-weight: normal;
  margin-bottom: ${props => props.theme.global.gutterSpace * 1.5}px;
`;

export const UL = styled.ul`
  padding-left: 1rem;
  font-size: ${props => props.theme.fontSizes[2]};
  line-height: 25px;
  color: ${props => props.theme.colors.purple700};

  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `}

  a {
    font-size: ${props => props.theme.fontSizes[2]};
    color: ${props => props.theme.colors.purple700};

    &:hover {
      color: ${props => props.theme.colors.purple900};
      text-decoration: underline;
    }
  }
`;

export const P = styled.p`
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  font-size: ${props => props.theme.fontSizes[2]};
  line-height: 1.3;
  color: ${props => props.theme.colors.grey700};
  margin: 0 0 ${props => `${props.theme.global.gutterSpace}px`};
`;

export const DetectiveContainer = styled.div`
  width: 100%;
  max-width: 400px;
  order: 2;

  svg {
    width: 100%;
    height: auto;
  }

  ${device.mobile} {
    order: 1;
    padding: ${props => `${props.theme.global.gutterSpace}px`};
    margin: 0 auto;
    max-width: 250px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${device.mobile} {
    align-items: center;
  }
`;
